import { render, staticRenderFns } from "./CleaningService.vue?vue&type=template&id=dadd7b7c&scoped=true&"
import script from "./CleaningService.vue?vue&type=script&lang=js&"
export * from "./CleaningService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadd7b7c",
  null
  
)

export default component.exports